export default __webpack_public_path__ + "static/media/NotoSans-Italic.326dc17f.ttf";